import Script from "next/script";

export default function FBPixelScript({ FB_PIXEL_IDS, onlyContent = false }) {
  const noScriptImage = (
    <noscript>
      {FB_PIXEL_IDS.map((FB_PIXEL_ID, index) => (
        <img
          key={index}
          height="1"
          width="1"
          style={{ display: "none" }}
          src={`https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1`}
        />
      ))}
    </noscript>
  );
  const content = (
    <>
      {noScriptImage}
      {/* Refer to https://developers.facebook.com/ads/blog/post/v2/2017/11/28/event-tracking-with-multiple-pixels-tracksingle/ */}
      <Script>
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          ${FB_PIXEL_IDS.map(
            (FB_PIXEL_ID) => `fbq('init', ${FB_PIXEL_ID}); fbq('track', "PageView");`
          ).join("\n")}
        `}
      </Script>
    </>
  );

  return onlyContent ? content : <>{content}</>;
}
